import React, { PropTypes } from "react";
import ComponentRegistry from "Fratello/Common/ComponentRegistry"

import StepperController from "../../../../../../../src-js/Fratello/Common/Controllers/StepperController";
import VariationController from "../../../../../../../src-js/Fratello/ProductPurchase/Controllers/VariationController";
import WishlistController from "../../../../../../../src-js/Fratello/ProductPurchase/Controllers/WishlistController";
import PricingController from "../../../../../../../src-js/Fratello/ProductPurchase/Controllers/PricingController";
import PersonalisationController from "../../../../../../../src-js/Fratello/ProductPurchase/Controllers/PersonalisationController";

function PackagingUnitsView({ packageUnits }) {
    if (packageUnits.length === 0) {
        return null;
    }
    return (
      <fieldset>
        <ul className="box-text list-none">
          {packageUnits.map((packageUnit, index) => (
            <li key={index} className="list-item">
              {packageUnit.label}
            </li>
                    ))}
        </ul>
      </fieldset>
    );
}
PackagingUnitsView.propTypes = {
    packageUnits: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
    }).isRequired),
};

function VolumePricing({ volumePricing }) {
    if (Object.values(volumePricing).length === 0) {
        return null;
    }
    const volumePrices = Object.values(volumePricing)
        .map((volumePrice, index) => (<li key={index} className="list-item">
          <span>{volumePrice.label}</span>
        </li>));
    return (
      <fieldset>
        <ul className="box-text list-none">
          {volumePrices}
        </ul>
      </fieldset>
    );
}
VolumePricing.propTypes = {
    volumePricing: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
    }).isRequired),
};

function Feedback({ feedback }) {
    if (!feedback) {
        return null;
    }
    return (
      <div className={'alert alert-' + feedback.type}>{feedback.message}</div>
    );
}

Feedback.propTypes = {
    feedback: PropTypes.shape({
        type: PropTypes.string.isRequired,
        message: PropTypes.string.isRequired,
    }),
};

export default function PurchaseView({
    product,
    variations,
    quantity,
    priceInclVat,
    labels,
    pricing,
    feedback,
    wishlist,
    personalisation,
    customizedProperties,
    onPurchase,
    onChange,
    onUpdateProduct,
    onCustomizedPropertiesChange,
}) {
    const Price = ComponentRegistry.get("ProductPurchasAtomsPrice");
    return (<div>
                <div className="field-group pull-right">
                    <div className="field-label">
                        <StepperController
                            value={quantity}
                            onChange={value => onChange({ quantity: value })}
                            min={product.minimumPurchaseAmount}
                            step={product.multipleFactor}
                            labels={labels}
                        />
                    </div>
                    {product.state !== "purchasable" ? <span className="btn btn-primary disabled">{labels.states[product.state]}</span>  :
                    <button onClick={onPurchase} className="btn btn-primary">{labels.purchase}</button> }
                </div>
                <Feedback feedback={feedback} />
            </div>);
}
PurchaseView.propTypes = {
    product: PropTypes.shape({
        state: PropTypes.string.isRequired,
        packageUnits: PropTypes.array.isRequired,
        volumePricing: PropTypes.array.isRequired,
        distinguishingProperties: PropTypes.shape.isRequired,
        minimumPurchaseAmount: PropTypes.number.isRequired,
        multipleFactor: PropTypes.number.isRequired,
    }).isRequired,
    customizedProperties: PropTypes.shape({}).isRequired,
    labels: PropTypes.shape({
        states: PropTypes.shape({}).isRequired,
        purchase: PropTypes.string.isRequired,
    }).isRequired,
    priceInclVat: PropTypes.bool.isRequired,
    quantity: PropTypes.number.isRequired,
    feedback: PropTypes.shape({
        type: PropTypes.string.isRequired,
        message: PropTypes.string.isRequired,
    }),
    pricing: PropTypes.shape({}),
    wishlist: PropTypes.shape({}),
    variations: PropTypes.shape({}),
    personalisation: PropTypes.shape({}),
    onUpdateProduct: PropTypes.func.isRequired,
    onPurchase: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onCustomizedPropertiesChange: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/ProductPurchase/Views/PurchaseView.jsx